export const sbxAsset = {
  route: () => import('./SbxAsset.vue'),
  propTypes: {
    className: {
      type: String,
      required: true,
    },
  },
};
